export default "__VITE_ASSET__QXMrPZ3o__"